(function (angular, app) {
    'use strict';

    app.filter('productName', ['$filter', function ($filter) {
        var _nameFilter = $filter('name'),
            _translateFilter = $filter('translate'),
            _productWeightFilter = $filter('productWeight');

        return function (product, isCase, type) {
            var itemsInCase = product && product.branch && product.branch.case && product.branch.case.items;
            if (isCase && product.isWeighable) {
                itemsInCase = _productWeightFilter(product, true);
            }
            
            var filteredNames = product ? _nameFilter(product.names) : '';
            return product && filteredNames && filteredNames[type || 'short'] + (isCase ? ' - ' + _translateFilter('Case' + (!!itemsInCase ? ' of' : '')) + (!!itemsInCase ? ' ' + itemsInCase : '') : '');
        };
    }]);
})(angular, app);
